// extracted by mini-css-extract-plugin
export default {"input":"PhoneNumberCell_input__qtg6J","cell":"PhoneNumberCell_cell__599fe"};